import { combineReducers, configureStore } from "@reduxjs/toolkit";
import notificationReducer from "./slices/notificationSlice";
import botReducer from "./slices/botSlice";
import strategyReducer from "./slices/strategySlice";
import userReducer from "./slices/userSlice";
import decimalReducer from "./slices/decimalSlice";
import customBotReducer from "./slices/customBotSlice";
import telegramReducer from "./slices/telegramSlice";
import sharedSlice from "./slices/sharedData";
import appSettingsReducer from "./slices/appSettingsSlice";

const rootReducer = combineReducers({
  notifications: notificationReducer,
  bot: botReducer,
  user: userReducer,
  decimal: decimalReducer,
  customGridMode: customBotReducer,
  strategy: strategyReducer,
  telegramSettings: telegramReducer,
  shared: sharedSlice,
  appSettings: appSettingsReducer,
});

export const setupStore = () => {
  return configureStore({
    reducer: rootReducer,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
